import { useMemo } from "react";
import dayjs from "../../../../../../../configs/dayjs";

export const useGetDateDiff = (data: any) => {
  const date = useMemo(() => {
    const { paymentDate } = data;

    const value = paymentDate ? dayjs(paymentDate).format("MMM D, YYYY") : "-";

    let diff = dayjs().diff(dayjs(paymentDate), "d", true);

    if (diff < 0) {
      diff = Math.floor(diff);
    } else {
      diff = Math.round(diff);
    }

    return {
      value,
      diff,
    };
  }, [data]);

  return { date };
};
